import React, { useEffect } from 'react';
import { debounce } from 'debounce';
import { useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import styles from './styles/styles.module.scss';
import FeedPane from '../FeedPane';
import ConnectPane from '../ConnectPane';
import ModalRenderer from '../ModalRenderer';
import { setClientLoad, setWindowWidth } from '../../ducks/browserWindow';
import { populateInitialConnections } from '../../ducks/belay';

const Community = () => {
  const dispatch = useDispatch();

  const handleInitialLoad = () => {
    const payload = {
      windowWidth: window.innerWidth,
      hydrated: true
    };
    dispatch(setClientLoad(payload));
    dispatch(populateInitialConnections());
  };

  const handleResize = () => {
    dispatch(setWindowWidth(window.innerWidth));
  };

  useEffect(() => {
    handleInitialLoad();
    window.addEventListener('resize', debounce(handleResize, 300));

    return () => {
      window.removeEventListener('resize', debounce(handleResize, 300));
    };
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.feedContainer}>
          <Route path="*/community/feeds/:feedKey?" exact component={FeedPane} />
          <Route path="*/community" exact>
            <Redirect to="/community/feeds" />
          </Route>
        </div>
        <div className={styles.paneSpacer} />
        <div className={styles.connectContainer}>
          <ConnectPane />
        </div>
      </div>
      <ModalRenderer />
    </>
  );
};

export default Community;
